import { authActions } from './actions';
import { authSelectors } from './selectors';
import { authTypes } from './types';

export const auth = {
    types: authTypes,
    actions: authActions,
    selectors: authSelectors,
};
